import React from 'react';
import { compose } from 'lodash/fp';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import styled from 'styled-components';
import { withTranslation, withTableSort } from '../../hoc';
import { Button } from '../FormItems';


const ContentTemplateWrapper = styled.div`
  div.table-responsive {
    height: auto;
    min-height: 500px;
    max-height: 700px;
    background: var(--admincat-color-grey-1);
  }
`;

 const StyledButton = styled(Button)`
  color:hsl(0, 0.00%, 100.00%);
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  width: 20%; 
  margin-left: 0; /* This will shift the button to the right */
  margin-left: auto;

`;

const TableWrapper = styled.div.attrs(() => ({
  className: 'table-responsive',
}))`
  height: 250px;

  @media (max-width: 600px) {
    // min-height: 300px;
    // height: 400px;
  }
`;

export const Table = styled.table`
  width: 100%;

  thead,
  tbody {
    white-space: nowrap;
  }

  && th,
  && td {
    height: 36px;
    line-height: 40px;
    padding: 0 1rem;
  }

  th {
    cursor: pointer;
    user-select: none;
    background: ${({ darkTableHeaderBg }) => {
      return darkTableHeaderBg ? 'var(--admincat-color-grey-1)' : '#fff';
    }};

    position: sticky;
    top: 0px;
    z-index: 200;
    p {
      font-size: 1rem;
      display: inline-block;
      transform: translateY(1px);
    }
  }

  tbody tr {
    // background: #fff;
    background: var(--admincat-color-grey-1);
    transition: background 0.4s;
    ${
      '' /* text-align: right;
    padding-right: 33%;   */
    }
  }

  tbody tr:hover {
    background: rgba(0, 0, 0, 0.08);
  }
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h2`
  font-size: 16px;
  color: var(--admincat-color-grey-3);
  margin-left: 20px;
  padding-top: 15px;

`;

const ContentTemplate = (props) => {
  const {
    className,
    tr,
    renderTableBody = (props) => <ContentTemplate.TableBody {...props} />,
    renderTableHeader = (props) => <ContentTemplate.TableHeader {...props} />,
    darkTableHeaderBg = true,
    raisedTable = true,
    showHeader = true,
    onActionClick = () => {},
    showActionButton = false,
    isActionButtonDisabled = false,
  } = props;

  return (
    <ContentTemplateWrapper className={className}>
      {(showHeader || props.title) && (
        <Header className="row">
          {props.title && <Title >{tr(props.title)}</Title>}
          {showActionButton && (
            <StyledButton
              actionButton
              name={tr('Make Payment')}
              style={{ marginBottom: '10px', marginTop: '10px', marginRight: '15px' }}
              onClick={() => {
                onActionClick();
              }}
              disabled={isActionButtonDisabled}
            />
          )}
        </Header>
      )}
      <TableWrapper className={`${raisedTable ? 'card' : ''}`} onScroll={props.onScroll}>
        <Table darkTableHeaderBg={darkTableHeaderBg} className="table">
          <thead>
            <tr>
              {renderTableHeader ? renderTableHeader(props) : props.tableHeader}
            </tr>
          </thead>
          <tbody>{renderTableBody ? renderTableBody(props) : props.tableBody}</tbody>
        </Table>
      </TableWrapper>
    </ContentTemplateWrapper>
  );
};

ContentTemplate.TableHeader = TableHeader;
ContentTemplate.TableBody = TableBody;

export default compose(withTranslation, withTableSort)(ContentTemplate);
